import React from 'react';

const AdminSettings = () => {
    return (
        <>
            
        </>
    );
};

export default AdminSettings;
